<div class="stepper">
  <button type="button" class="stepperButton" [disabled]="quantity <= 0" (click)="onDecrement($event)" [attr.aria-label]="'QUANTITY.DECREASE' | translate" [title]="'QUANTITY.DECREASE' | translate">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 12h12" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" fill="none" />
    </svg>
  </button>
  <span class="stepperValue" [class.empty]="quantity <= 0" aria-live="polite">{{ quantity }}</span>
  <button type="button" class="stepperButton stepperAdd" (click)="onIncrement($event)" [attr.aria-label]="'QUANTITY.INCREASE' | translate" [title]="'QUANTITY.INCREASE' | translate">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 6v12M6 12h12" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" fill="none" />
    </svg>
  </button>
</div>
